import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { WhoRewardedRewardTypes, WhoRewardedTypes } from "@irati/reward/enums/WhoRewardedTypes";
export var getUserText = function (formatMessage, userType, user) {
    var addedBy = formatMessage({ id: "recognition.whoRewarded.addedBy" });
    var sender = userType === WhoRewardedTypes.SENDER ? formatMessage({ id: "recognition.whoRewarded.you" }) : firstnameLastname(user);
    return addedBy + " " + sender;
};
export var getRewardText = function (rewardType, formatMessage) {
    if (rewardType === WhoRewardedRewardTypes.CREDIT_REWARD) {
        return formatMessage({ id: "recognition.whoRewarded.credit" });
    }
    return formatMessage({ id: "recognition.whoRewarded.reward" });
};
export var getRewardDescription = function (reward, rewardOrder, rewardType) {
    switch (rewardType) {
        case WhoRewardedRewardTypes.CUSTOM_OLD_REWARD:
        case WhoRewardedRewardTypes.OLD_REWARD:
            return { text: reward.desc };
        case WhoRewardedRewardTypes.NEW_REWARD:
            return {
                text: rewardOrder.reward.header,
                costPerUnit: rewardOrder.costPerUnit
            };
        case WhoRewardedRewardTypes.CUSTOM_NEW_REWARD:
            return { text: rewardOrder.custom };
        case WhoRewardedRewardTypes.CREDIT_REWARD:
            return { text: "credit amount" };
        // @todo add credit amount
        default:
            return { text: " " };
    }
};
